import * as React from 'react';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

import HealthcareProviderCreateContainer from '~/containers/HealthcareProviders/HealthcareProviderCreate';
import { Panel } from '@watcherr/ui';
import { ProfileTable } from '~components/DeviceTables/ProfileTable';
import { ProfileType } from '@watcherr/resources';
import { Permission } from '@watcherr/resources';

const HealthcareProvidersPage: React.FC = () => {
  const [creationPermission, setCreationPermission] = React.useState<boolean>(false);
  const [editPermission, setEditPermission] = React.useState<boolean>(false);
  const [deletePermission, setDeletePermission] = React.useState<boolean>(false);

  React.useEffect(() => {
    Permission.getOwnPermissions().then((value) => {
      if (value.length != 0) {
        value[0].entries.find((perm) => {
          if (perm.permission.name.includes('')) {
            if (perm.isEnabled) {
              setCreationPermission(true);
            }
          }
          if (perm.permission.name.includes('can_edit_all_profiles')) {
            if (perm.isEnabled) {
              setEditPermission(true);
            }
          }
          if (perm.permission.name.includes('can_delete_all_profiles')) {
            if (perm.isEnabled) {
              setDeletePermission(true);
            }
          }
        });
      }
    });
  }, []);
  return (
    <>
      <Panel>
        <ProfileTable
          profileType={ProfileType.HealthcareProvider}
          editPermissions={editPermission}
          deletePermissions={deletePermission}
        />
      </Panel>
      {creationPermission && <HealthcareProviderCreateContainer />}
    </>
  );
};

export default dashboardWrapper(HealthcareProvidersPage, t('menu.dashboard.healthcareProviders'));
